import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-038e7047"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  key: 0,
  class: "page-header"
}
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数据任务管理", -1 /* HOISTED */))
const _hoisted_6 = { class: "layout-body" }
const _hoisted_7 = { class: "layout-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 顶部 Header（index.html?cls=xxx 模式时显示） "),
    (_ctx.$slots.default && $setup.isBizMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode($setup["FileTextOutlined"], { class: "logo-icon" }),
              _hoisted_5
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 主体区：左侧菜单 + 右侧内容 "),
    _createElementVNode("div", _hoisted_6, [
      _createVNode($setup["layoutSiderbar"]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.$slots.default)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ])
    ])
  ]))
}